import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from './AppContext';
import './Testimonials.css';

const FALLBACK_TESTIMONIALS = [
  {
    id: 't1',
    img: '/images/men ring2.jpg',
    name: 'Rajesh Sharma',
    role: 'Jeweller, Mumbai',
    roleMr: 'ज्वेलर, मुंबई',
    text: 'GDR Jewellers provides the highest purity silver ornaments. Their wholesale pricing and delivery speed are unparalleled.',
    textMr: 'जीडीआर ज्वेलर्स सर्वोच्च शुद्धतेचे चांदीचे दागिने पुरवतात. त्यांची होलसेल किंमत आणि डिलिव्हरी स्पीड अतुलनीय आहे.'
  },
  {
    id: 't2',
    img: '/images/painjan10.jpg',
    name: 'Anita Patel',
    role: 'Retailer, Ahmedabad',
    roleMr: 'रिटेलर, अहमदाबाद',
    text: 'The Payal & Anklet range is extremely popular with our customers. The finishing on the silver is flawless!',
    textMr: 'पैंजण आणि अँकलेट रेंज आमच्या ग्राहकांमध्ये खूप लोकप्रिय आहे. चांदीवरील फिनिशिंग अप्रतिम आहे!'
  },
  {
    id: 't3',
    img: '/images/w br14.jpg',
    name: 'Vikram Mehta',
    role: 'Wholesaler, Delhi',
    roleMr: 'होलसेलर, दिल्ली',
    text: "Excellent catalog selections. The men's chain series and custom cuff bracelets sell out immediately in our stores.",
    textMr: 'उत्कृष्ट कॅटलॉग निवड. पुरुषांची चेन सीरिज आणि कस्टम कफ ब्रेसलेट आमच्या दुकानात लगेच विकले जातात.'
  },
  {
    id: 't4',
    img: '/images/w ring1.jpg',
    name: 'Priyanka Sen',
    role: 'Boutique Owner, Kolkata',
    roleMr: 'बुटीक ओनर, कोलकाता',
    text: 'Highly recommend their hallmarked collection. Customer support answers enquiries fast and accommodates custom sizes.',
    textMr: 'त्यांच्या हॉलमार्क कलेक्शनची मी जोरदार शिफारस करते. ग्राहक सेवा चौकशींना लवकर उत्तर देते आणि कस्टम साईझ सामावून घेते.'
  },
  {
    id: 't5',
    img: '/images/painjan19.jpg',
    name: 'Devendra Joshi',
    role: 'Showroom Owner, Jaipur',
    roleMr: 'शोरूम ओनर, जयपूर',
    text: 'Stunning designs and consistent 92.5 purity. The wholesale ordering flow is very transparent and reliable.',
    textMr: 'अप्रतिम डिझाईन्स आणि सातत्यपूर्ण 92.5 शुद्धता. होलसेल ऑर्डरिंग प्रक्रिया अतिशय पारदर्शक आणि विश्वासार्ह आहे.'
  },
  {
    id: 't6',
    img: '/images/men br8.jpg',
    name: 'Siddharth Roy',
    role: 'Distributor, Chennai',
    roleMr: 'डिस्ट्रिब्युटर, चेन्नई',
    text: 'Their range of heavy silver bracelets and kada styles has helped us grow our retail customer base significantly.',
    textMr: 'त्यांच्या जड चांदीच्या ब्रेसलेट आणि कडा स्टाईल्सच्या रेंजमुळे आम्हाला आमचा रिटेल ग्राहक आधार लक्षणीयरीत्या वाढवता आला.'
  },
  {
    id: 't7',
    img: '/images/w ring2.jpg',
    name: 'Meenakshi Iyer',
    role: 'Boutique Designer, Bangalore',
    roleMr: 'बुटीक डिझायनर, बंगळुरू',
    text: 'The artisan craftsmanship on the custom waist chains is highly detailed. A solid partnership for our brand.',
    textMr: 'कस्टम कंबरपट्ट्यांवरील कारागीर कलाकुसर अत्यंत सूक्ष्म आहे. आमच्या ब्रँडसाठी एक भक्कम भागीदारी.'
  }
];

const Testimonials = () => {
  const { lang, testimonials: ctxTestimonials } = useContext(AppContext);
  const isMr = lang === 'mr';
  const [active, setActive] = useState(0);

  // Use testimonials from context (Firestore) if available, else fallback
  const list = (ctxTestimonials && ctxTestimonials.length > 0) ? ctxTestimonials : FALLBACK_TESTIMONIALS;

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % list.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [list.length]);

  const getText = (t, field) => {
    if (isMr && t[`${field}Mr`]) return t[`${field}Mr`];
    return t[field];
  };

  return (
    <section className="testimonials-section reveal">
      <div className="section-header">
        <h2 className="section-title">{isMr ? 'होलसेलर्स काय म्हणतात' : 'What Wholesalers Say'}</h2>
        <div className="title-ornament">
          <span /><span className="ornament-diamond">◆</span><span />
        </div>
      </div>

      <div className="testimonials-wall">
        {list.map((t, idx) => (
          <div
            key={t.id || idx}
            className={`testimonial-card-tile ${idx === active ? 'card-highlighted' : ''}`}
            onClick={() => setActive(idx)}
          >
            <div className="hanging-rope">
              <div className="rope-line" />
              <div className="rope-nail" />
            </div>

            <div className="card-tile-top">
              <img src={t.img} alt={t.name} className="client-img" />
              <div className="client-meta">
                <h4 className="client-name">{t.name}</h4>
                <span className="client-role">{getText(t, 'role')}</span>
              </div>
            </div>
            <p className="client-quote">"{getText(t, 'text')}"</p>
            <div className="card-tile-accent" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
